import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ items, index, setIndex }) {
  const open = index !== null && index !== undefined && items[index];

  useEffect(() => {
    if (index === null || index === undefined) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIndex(null);
      if (e.key === "ArrowRight") setIndex((p) => (p + 1) % items.length);
      if (e.key === "ArrowLeft") setIndex((p) => (p - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, items.length, setIndex]);

  const next = (e) => { e?.stopPropagation(); setIndex((p) => (p + 1) % items.length); };
  const prev = (e) => { e?.stopPropagation(); setIndex((p) => (p - 1 + items.length) % items.length); };
  const caption = open ? (items[index].caption || items[index].title) : null;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="lightbox"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={() => setIndex(null)}
          className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/95"
          style={{ backdropFilter: "blur(20px)" }}
        >
          <button data-testid="lightbox-close" onClick={() => setIndex(null)}
            className="absolute top-5 right-5 p-3 rounded-full text-[#FBF8F5] hover:text-[#D4AF37] transition-colors z-10"><X className="w-6 h-6" /></button>
          {items.length > 1 && (
            <>
              <button data-testid="lightbox-prev" onClick={prev}
                className="absolute left-3 sm:left-8 p-3 rounded-full bg-black/40 text-[#FBF8F5] hover:text-[#D4AF37] border border-[#D4AF37]/20 transition-colors z-10"><ChevronLeft className="w-6 h-6" /></button>
              <button data-testid="lightbox-next" onClick={next}
                className="absolute right-3 sm:right-8 p-3 rounded-full bg-black/40 text-[#FBF8F5] hover:text-[#D4AF37] border border-[#D4AF37]/20 transition-colors z-10"><ChevronRight className="w-6 h-6" /></button>
            </>
          )}
          <motion.figure
            key={items[index].id || index}
            initial={{ scale: 0.94, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-5xl w-full text-center"
          >
            <img src={items[index].image_url} alt={caption || "Afrodite"}
              className="max-h-[78vh] w-auto mx-auto rounded-xl object-contain shadow-2xl" />
            {caption && (
              <figcaption className="mt-5 font-display text-lg sm:text-xl text-[#F3E5AB] tracking-wide">{caption}</figcaption>
            )}
            {items.length > 1 && <p className="mt-1 text-xs text-[#6E6865] tracking-widest">{index + 1} / {items.length}</p>}
          </motion.figure>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
